import MscratchService from '../services/mscratch';
import ProjectService from '../services/api/project';
import {openProjectTarget} from '../util';
import ExtensionAction from '../reducers/extension/action';


class Project {
    constructor() {
    }

    reset() {
        MscratchService.clear();
    }

    /**
     * 导出项目
     * @param  projectInfo  项目的基本信息
     * {
     *     name: 'demo'
     * }
     */
    export(projectInfo) {
        MscratchService.export(null, null, projectInfo);
    }

    /**
     * 导入项目
     * @param success 导入成功后的回调
     */
    async import(success) {
        success = success ? success : ()=>{};
        if (!document.querySelector('#OpenProjectTarget')) {
            let openInput = document.createElement('input');
            openInput.setAttribute('type', 'file');
            openInput.setAttribute('id', 'OpenProjectTarget');
            openInput.setAttribute('hidden', true);
            document.body.appendChild(openInput);
        }
        let file = await openProjectTarget('#OpenProjectTarget');
        let data = await MscratchService.useWebRead(file);
        try {
            const exts = await MscratchService.renderProject(data.data, success);
            if (exts.exts) {
                ExtensionAction.load(exts.exts);
            }
        } catch (error) {
            console.warn(error);
        }
    }

    /**
     * 获取封面截图
     * @returns base64 编码
     */
    getCover() {
        return MscratchService.getProjectCoverPic();
    }

    /**
     * 注入数据
     * @param {ArrayBuffer} projectData
     * @param {Funcion} success （可选）渲染成功后的回调
     */
    async renderFromArrayBuffer(projectData, success) {
        success = success ? success : () => {};
        try {
            const exts = await MscratchService.renderProject(projectData, success);
            if (exts.exts) {
                ExtensionAction.load(exts.exts);
            }
        } catch (error) {
            console.warn(error);
        }
    }

    /**
     * 获取 makeblock 项目数据
     * @param {String} url 项目地址，例如：http://mblock.makeblock.com/project/13309
     * @param {Function} callback 获取数据后的回调函数
     */
    fetchMblockCloudProjectData(url, callback) {
        if (!url) return null;
        try {
            let projectId = url.split('/project/')[1];
            let hash = `cloudProjectId=${projectId}`;
            ProjectService.loadRemoteProjectFromUrl(hash).then((bufferData) => {
                callback(bufferData);
            });
        } catch (error) {
            callback(null);
        }
    }
}

export default Project;